<template>
  <div class="content">
    <div></div>
    <packageTable
      ref="contentBaseRef"
      class="contentBaseRef"
      :columnsData="columnsheader"
      :tableData="tableDataList"
      :reduceheight="reduceheight"
      :loading="tableLoading"
      :border="true"
      :tabletotallen="getPageTotal"
      :showSearchBtn="false"
      :tablePageSize="reqBase.page_size"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @refreshBtn="init"
      @getSelect="getSelectList"
    >
      <template slot="headLeft">
        <Form ref="formInline" class="tableHeaderForm" :model="form_filter" :label-width="0" @keydown.enter.native="search" inline>
          <FormItem label>
            <Input type="text" v-model="form_filter.device_code" style="width:120px" placeholder="设备编号筛选" />
          </FormItem>
          <FormItem label>
            <Input type="text" v-model="form_filter.did" style="width:120px" placeholder="设备id筛选" />
          </FormItem>
          <FormItem>
            <Select v-model="form_filter.alarm_type_code" placeholder="全部报警类型" filterable style="width:120px">
              <Option v-for="(item,index) in alarmTypeList" :value="item.alarm_type_code" :key="index">{{ item.alarm_type_name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="form_filter.cate_code" filterable placeholder="全部防制分类" style="width:120px">
              <Option v-for="item in preventCateList" :value="item.cate_code" :key="item.cate_code">{{ item.cate_name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="form_filter.status" filterable placeholder="全部状态" style="width:120px">
              <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <DatePicker transfer style="width:120px" v-model="time" type="daterange" placement="bottom-end" @on-change="timeChange" placeholder="请选择时间"></DatePicker>
          </FormItem>
          <Button v-for="(item,index) in topButtonList" :type="item.type" style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
        </Form>
      </template>
      <template slot="headRight">
        <Tooltip v-for="(item,index) in topButtonList1" :key="index" :content="item.name" placement="bottom">
          <Button :type="item.type" style="margin-right: 5px;" @click="item.method" :key="index" :icon="item.icon"></Button>
        </Tooltip>
      </template>
    </packageTable>
    <customDetails ref="customDetails" :setData="setData" @init="init" />
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins"
import addAppCustom from "./components/addAppCustom"
import customDetails from "./components/customDetails.vue"
import config from "@/config/index"
import { alarm_about, alarm_list, alarm_del, handle_alarm } from "@/api/pests"
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      time: [],
      preventCateList: [], //防制分类
      alarmTypeList: [], //报警类型
      setData: null,
      currClientId: null, //当前选择的应用id
      form_filter: {
        project_name: null,
        alarm_type_code: null,
        cate_code: null,
        start_time: null,
        end_time: null,
        status: null,
        device_code: null
      },
      statusList: [
        {
          value: "",
          label: "全部"
        },
        {
          value: 1,
          label: "未处理"
        },
        {
          value: 2,
          label: "已处理"
        }
      ],
      //共用的查询与重置
      topButtonList: [
        {
          name: "查询",
          type: "primary",
          method: this.search
        },
        {
          name: "重置",
          type: "error",
          method: this.reset
        }
      ],
      //共用的右侧添加按钮
      topButtonList1: [
        // {
        //   name:'添加',
        //icon:'ios-add',
        //   type:'primary',
        //   method:this.add
        // },
        {
          name: "刷新",
          icon: "ios-refresh",
          type: "primary",
          method: this.init
        }
      ],
      reqBase: {
        page: 1,
        page_size: 15
      },
      status: true, //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [
        {
          name: "处理",
          type: "text",
          icon: "",
          show: [1],
          method: this.edit
        },
        {
          name: "删除",
          type: "text",
          icon: "",
          method: this.del
        }
      ],
      operationButtonList1: [
        {
          name: this.$t("operationModule.submitReview"),
          type: "text",
          icon: "",
          method: this.submitReview
        }
      ],
      columnsheader: [
        // {
        //   align: "center",
        //   title: "序号",
        //   width: 80,
        //   key: "xuhao"
        // },
        {
          align: "center",
          title: "设备编号",
          minWidth: 120,
          key: "device_code"
        },
        {
          align: "center",
          title: "设备Id",
          minWidth: 120,
          key: "device_id"
        },
        {
          align: "center",
          title: "设备名称",
          minWidth: 120,
          key: "device_name"
        },
        {
          align: "center",
          title: "报警类型",
          minWidth: 120,
          key: "alarm_type_name"
        },
        {
          align: "center",
          title: "防制分类",
          minWidth: 120,
          key: "cate_name"
        },
        {
          align: "center",
          title: "报警时间",
          minWidth: 120,
          key: "alarm_time"
        },
        {
          align: "center",
          title: "所属区域",
          minWidth: 120,
          key: "address"
        },
        {
          align: "center",
          title: "所属建筑物",
          minWidth: 120,
          key: "building_name"
        },
        // {
        //   align: 'center',
        //   title: '楼层',
        //   minWidth:120,
        //   key: 'floor_num'
        // },
        {
          align: "center",
          title: "状态",
          minWidth: 120,
          key: "status",
          render: (h, { row }) => {
            let color = ""
            let text = ""
            if (row.status === 2) {
              color = "success"
              text = "已处理"
            } else if (row.status === 1) {
              color = "error"
              text = "未处理"
            }
            return h(
              "Tag",
              {
                props: {
                  color: color
                }
              },
              text
            )
          }
        },
        {
          align: "center",
          title: "处理人",
          minWidth: 120,
          key: "handle_user_name"
        },
        {
          align: "center",
          title: "处理时间",
          minWidth: 120,
          key: "handle_user_time"
        },
        {
          align: "center",
          title: "操作",
          fixed: "right",
          minWidth: 150,
          key: "Operating",
          render: (h, { row }) => {
            let arr = []
            for (let i in this.operationButtonList) {
              let list = this.operationButtonList[i]
              if (list.hasOwnProperty("show")) {
                if (list.show.indexOf(row.status) > -1) {
                  arr.push(
                    h(
                      "Button",
                      {
                        style: {
                          marginLeft: "5px",
                          marginBottom: "3px",
                          color: "#2d8cf0"
                        },
                        props: {
                          type: list.type,
                          size: list.size ? list.size : "small"
                        },
                        on: {
                          click: () => {
                            list.method(row)
                          }
                        }
                      },
                      list.name
                    )
                  )
                }
              } else {
                arr.push(
                  h(
                    "Button",
                    {
                      style: {
                        marginLeft: "5px",
                        marginBottom: "3px",
                        color: "#2d8cf0"
                      },
                      props: {
                        type: list.type,
                        size: list.size ? list.size : "small"
                      },
                      on: {
                        click: () => {
                          list.method(row)
                        }
                      }
                    },
                    list.name
                  )
                )
              }
            }

            return h("div", arr)
          }
        }
      ]
    }
  },
  components: {
    customDetails
  },
  props: {
    code: {}
  },
  computed: {},
  methods: {
    timeChange(val) {
      this.$set(this.form_filter, "start_time", val[0])
      this.$set(this.form_filter, "end_time", val[1])
    },
    mechanHome(row) {
      window.open(config.webLinkUrl + "/index/" + row.company_code)
    },
    pageSizeChange() {},
    init() {
      this.tableLoading = true
      alarm_list({ ...this.reqBase }).then((res) => {
        this.tableLoading = false
        this.tableDataList = []
        if (res.result === 0) {
          this.tableDataList = res.body.list || []
          this.getPageTotal = res.body.total
        } else {
          this.tableDataList = []
          this.getPageTotal = 0
          this.$Message.error(res.errorMsg)
        }
      })
    },
    //新增
    add() {
      let vm = this
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  "处理报警"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false
              }
            })
          ])
        },
        onOk: function () {
          let _this = this
          let obj = this.$refs.addAppCustom
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel
              handle_alarm(formModel).then((res) => {
                let msg = res.errorMsg
                if (res.result === 0) {
                  let msg = res.errorMsg
                  vm.$Message.success(msg)
                  vm.$Modal.remove()
                  vm.init()
                } else {
                  vm.$Message.error(msg)
                  _this.buttonLoading = false
                }
              })
            } else {
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    search() {
      this.onSearch(this.form_filter)
    },
    reset() {
      this.form_filter = {
        project_name: null,
        alarm_type_code: null,
        cate_code: null,
        start_time: null,
        end_time: null,
        status: null,
        device_code: null
      }
      this.time.splice(0)
      this.search()
    },
    details(row) {
      this.setData = row
      this.$refs.customDetails.showModal(true)
    },
    edit(row) {
      let vm = this
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  "处理报警"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                setData: row
              }
            })
          ])
        },
        onOk: function () {
          let _this = this
          let obj = this.$refs.addAppCustom
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel
              let { id, handle_type_code, handle_user_name, handle_user_time } =
                formModel
              handle_alarm({
                id,
                handle_type_code,
                handle_user_name,
                handle_user_time
              }).then((res) => {
                let msg = res.errorMsg
                if (res.result === 0) {
                  let msg = res.errorMsg
                  vm.$Message.success(msg)
                  vm.$Modal.remove()
                  vm.init()
                } else {
                  vm.$Message.error(msg)
                  _this.buttonLoading = false
                }
              })
            } else {
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    del(row) {
      let vm = this
      let config = {
        loading: true,
        title: "处理告警",
        content: "您确定要处理" + row.device_name + "的告警吗",
        onOk: function () {
          let _this = this
          alarm_del({ id: row.id }).then((res) => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg)
              vm.$Modal.remove()
              vm.init()
            } else {
              vm.$Message.error(res.errorMsg)
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    getAlertAbout() {
      alarm_about().then((res) => {
        if (res.result === 0) {
          this.alarmTypeList = res.body.alarm_type || []
          this.preventCateList = res.body.prevent_cate || []
          this.handleTypeList = res.body.handle_type || []
        }
      })
    }
  },
  mounted() {
    if (this.code) {
      this.$set(this.reqBase, "project_code", this.code)
    }
    this.init()
  },
  created() {
    this.getAlertAbout()
  }
}
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}
.contentBaseRef /deep/ .headerWrapper {
  align-items: center;
}
.contentBaseRef /deep/ .ivu-table-fixed,
.contentBaseRef /deep/ .ivu-table-fixed-right {
  top: 48px !important;
}
.content {
  background: #fff;
}
.colClass {
  margin-bottom: 8px;
}
</style>
